'use client';

import { ComponentProps } from 'react';
import { Sheet } from 'react-modal-sheet';
import { Box, Button } from '@wishket/design-system';

import { AutoExpandQuoteTextarea } from '@/shared/Components';
import { useAnimatedVirtualKeyboard } from '@/shared/hooks';

interface MobileMemoBottomSheetProps extends ComponentProps<'textarea'> {
  isOpen: boolean;
  setOpen: () => void;
  onSubmit: () => void;
  onClose: () => void;
}

const MobileMemoBottomSheet = ({
  onSubmit,
  onClose,
  style,
  isOpen,
  setOpen,
  ...rest
}: MobileMemoBottomSheetProps) => {
  const { keyboardHeight } = useAnimatedVirtualKeyboard();

  return (
    <Sheet
      isOpen={isOpen}
      onClose={setOpen}
      snapPoints={[600, 400]}
      initialSnap={0}
      data-testid="bottom-sheet-memo"
    >
      <Sheet.Backdrop onTap={onClose} />
      <Sheet.Container className="react-modal-sheet-container">
        <Sheet.Header />
        <Sheet.Content style={{ paddingBottom: keyboardHeight, ...style }}>
          <Box className="mb-10 h-full overflow-y-scroll px-5 pt-5 font-normal">
            <AutoExpandQuoteTextarea {...rest} />
          </Box>
          <Box className="flex w-full gap-4 px-5 py-4">
            <Button
              variant="solid"
              onClick={onClose}
              className="w-full border-w-bluegray-200 bg-w-bluegray-200 focus:bg-w-bluegray-300 active:bg-w-bluegray-300 hover:border-w-bluegray-300 hover:bg-w-bluegray-300"
            >
              취소
            </Button>
            <Button variant="solid" className="w-full" onClick={onSubmit}>
              저장
            </Button>
          </Box>
        </Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
};

export default MobileMemoBottomSheet;
